define ['./dueToOthersModal.css'], () ->
  ($scope, $rootScope, $state, $uibModalInstance, RentappService, $http, RENTAPPLICATION_API_URL, Flash, $cacheFactory) ->
    $scope.theme_color = $rootScope.THEME_COLOR
    $scope.reject_application = (with_email) ->
      send_data = 
        application_id: $scope.application.id
        with_email: with_email
      
      if with_email
        _.merge(send_data, {
          rejection_email_subject: $scope.email.subject
          rejection_email_body: $scope.email.body 
          cc_self: $scope.email.cc_self or false
        })
      
      $scope.rejecting = true
      $scope.reject_error = null

      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/application/#{$scope.application.id}/reject_application/",
        send_data
      .then ->
        $cacheFactory.get('$http').removeAll()
        $state.go $state.current.name, $state.params, reload: 'root'
      .catch (r) ->
        # TODO not really working, since it happens after modal close. Need to refactor. For now send button just disabled for empty body
        if r.status == 400
          Flash.create("danger", r.data.error)
        else
          Flash.create("danger", 'Unfortunately, an error has occured in processing this request. Please try again.')
      .finally ->
        $scope.rejecting = false



// WEBPACK FOOTER //
// ./directives/acceptRejectApplication/rejectApplication/dueToOthersModal/dueToOthersModal.coffee